<app-page-content>
  <span pagetitle>Bilde ({{selectedIndex + 1}} av {{attachmentIds.length}})</span>
  <app-button-box pageheaderactions>
    <button [disabled]="selectedIndex == 0" (click)="prevImage()" mat-icon-button color="primary">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button [disabled]="selectedIndex == attachmentIds.length - 1" (click)="nextImage()"
            mat-icon-button color="primary">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </app-button-box>
  <div pagecontent style="display: flex; flex-direction: row;">
    <span style="flex: 1 1 auto;"></span>
    <app-attachment [id]="selectedAttachmentId"
                    style="margin: 0.5em; width: auto; height: calc(640px + 2em); z-index: 0;"></app-attachment>
    <span style="flex: 1 1 auto"></span>
  </div>

  <app-button-box pagefooter>
    <button style="margin-right: 0.5em" mat-raised-button color="primary" (click)="close()">LUKK</button>
  </app-button-box>
</app-page-content>
